import { Lightning, Utils } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

const Constants = {
  h: 140,
  w: 220,
  alpha: 0.63,
  Icon: {
    y: 70,
  },
  Speed: {
    x: 170,
    y: 70,
  },
};

export class TrickPlayOverlay extends Lightning.Component {
  static _template() {
    return {
      h: Constants.h,
      w: Constants.w,
      alpha: Constants.alpha,
      ForwardIcon: {
        y: Constants.Icon.y,
        mountY: 0.5,
        src: Utils.asset('images/player/fast-forward-large.png'),
        visible: false,
      },
      RewindIcon: {
        y: Constants.Icon.y,
        mountY: 0.5,
        src: Utils.asset('images/player/fast-rewind-large.png'),
        visible: false,
      },
      Speed: {
        x: Constants.Speed.x,
        y: Constants.Speed.y,
        mountY: 0.5,
        text: {
          ...Theme.Fonts.Player.TrickPlayOverlay,
          text: '',
        },
      },
    };
  }

  /**
   * @param {PlayerController} playerController
   */
  registerEventHandler(playerController) {
    playerController.uiEventHandlers.updateTrickPlay = this.configureTrickPlay.bind(this);
  }

  /**
   * @param {boolean} forward
   * @param {number} speed
   */
  configureTrickPlay(forward, speed) {
    this.tag('Speed').text.text = `x ${speed}`;
    if (forward) {
      this.tag('ForwardIcon').visible = true;
      this.tag('RewindIcon').visible = false;
    } else {
      this.tag('ForwardIcon').visible = false;
      this.tag('RewindIcon').visible = true;
    }
  }
}
